import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import DatatablesIndexPage from 'datatables/pages/DatatablesIndexPage.vue';
import DatatableNewPage from 'datatables/pages/DatatableNewPage.vue';
import DatatableShowPage from 'datatables/pages/DatatableShowPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/flow/datatables'),
    component: DatatablesIndexPage,
    name: 'datatables_index',
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/flow/datatables/new'),
    component: DatatableNewPage,
    name: 'datatables_new',
    meta: {
      permissions: ['administrator'],
      featureFlag: FEATURE_FLAGS.FLOW,
    },
  },
  {
    path: frontendURL('accounts/:accountId/flow/datatables/:slug'),
    component: DatatableShowPage,
    name: 'datatables_show',
    meta: {
      permissions: ['administrator'],
      featureFlag: FEATURE_FLAGS.FLOW,
    },
  },
];
